import React from 'react';
import {
  Section,
  CardBase,
  InformativeTag,
  Label,
  List,
  ListItem,
  Tooltip,
  MainButton,
  LoadingShimmer
} from '@icarros/ids-react';
import {
  ResumeDetailsWrapper,
  ResumePlanCard,
  ResumePlanCardTitle,
  ResumePlanTitle
} from './style';
import { useAdContext } from '../../../store/contexts/ad';
import { formatPriceToReal, formatToDate, removePlural } from '../../../utils/formatters';
import { useHistory } from 'react-router-dom';
import { TERMS } from '../../../../utils/routes';
import { useRenewAd } from '../../../hooks/useRenewAd';
import { pushSellerPFDashboardEvent } from '../../../../utils/pushToDataLayer';
import { STATUS } from '../../../enum/listing-status';

export function PlanDetails(): JSX.Element {
  const history = useHistory();
  const { currentAd } = useAdContext();
  const { renewMutation } = useRenewAd(currentAd.id);

  const {
    dataPublicacao,
    dataValidade,
    filterName,
    filterText,
    podeRenovar,
    id: adId,
    meuPlano
  } = currentAd || {};
  const { preco, id, nome } = meuPlano?.plano || {};

  return (
    <ResumeDetailsWrapper>
      <Section size="section_1">meu plano</Section>
      <ResumePlanCard>
        <LoadingShimmer show={!currentAd} height="340px">
          <CardBase variant="default" hasHover={false} selected={false}>
            <ResumePlanCardTitle>
              {filterName === STATUS.active && (
                <InformativeTag type="success">{removePlural(filterText ?? '')}</InformativeTag>
              )}
              {(filterName === STATUS.analyzing || filterName === STATUS.expired) && (
                <InformativeTag type="error">{removePlural(filterText ?? '')}</InformativeTag>
              )}
              {(filterName === STATUS.waiting || filterName === STATUS.deactivated) && (
                <InformativeTag type="neutral">{removePlural(filterText ?? '')}</InformativeTag>
              )}

              <ResumePlanTitle>
                <Label size="medium" weight="bold" variant="neutral">
                  {nome?.replace('Plano ', '')}
                </Label>
                {id === 37 && (
                  <Tooltip>
                    A cada 90 dias o anúncio será desativado para evitar que carros já vendidos
                    continuem publicados no site.
                  </Tooltip>
                )}
              </ResumePlanTitle>
            </ResumePlanCardTitle>
            <List>
              <ListItem
                label="valor"
                descript={preco ? formatPriceToReal(preco) : ''}
                variant="simple"
              />
              {dataPublicacao ? (
                <ListItem
                  label="publicado em"
                  descript={formatToDate(dataPublicacao)}
                  variant="simple"
                />
              ) : (
                <></>
              )}
              {dataValidade ? (
                <ListItem
                  label="válido até"
                  descript={formatToDate(dataValidade)}
                  variant="simple"
                />
              ) : (
                <></>
              )}
              <ListItem
                label="acessar Termos de Adesão"
                variant="action"
                hasLine={false}
                actionOnClick={() => {
                  pushSellerPFDashboardEvent('acessar Termos de Adesão', `meu plano - ${nome}`);
                  history.push(TERMS);
                }}
              />
            </List>
            {podeRenovar && adId > 0 && (
              <MainButton
                onClick={() => renewMutation.mutate()}
                isLoading={renewMutation.isLoading}
                text="reativar anúncio"
                iconName="itaufonts_seta_right"
              />
            )}
          </CardBase>
        </LoadingShimmer>
      </ResumePlanCard>
    </ResumeDetailsWrapper>
  );
}
